const storagePrefix = "react_";

// Token storage utility
const storage = {
  getToken: () => {
    return JSON.parse(
      window.localStorage.getItem(`${storagePrefix}token`) as string
    );
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },
};

export default storage;

// Generic storage utility for app data
export const appStorage = {
  get: <T>(key: string): T | null => {
    try {
      const item = window.localStorage.getItem(`${storagePrefix}${key}`);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      return null;
    }
  },
  set: <T>(key: string, value: T): void => {
    try {
      window.localStorage.setItem(`${storagePrefix}${key}`, JSON.stringify(value));
    } catch (error) {
    }
  },
  remove: (key: string): void => {
    try {
      window.localStorage.removeItem(`${storagePrefix}${key}`);
    } catch (error) {
    }
  },
  clear: (): void => {
    try {
      window.localStorage.clear();
    } catch (error) {
    }
  },
};
